import { BasicsClass } from '@/common/BasicsClass';
import { Util } from '@/common/util';

export class BlueToothListAPI extends BasicsClass {
    public apiUrls: any = new Map([
        // ['forbideenBlueToothAccount', {
        //     url: '/user/forbid',
        //     name: 'account-forbid',
        //     label: '账户封禁'
        // }],
        ['getBlueToothTableList', {
            url: '/admin/deviceSwitch/lists',
            name: 'list',
            label: '列表'
        }],

        ['addBlueTooth', {
            url: '/admin/deviceSwitch/add',
            name: 'add-light-theme',
            label: '添加蓝牙开关'
        }],

        ['editBlueTooth', {
            url: '/admin/deviceSwitch/update',
            name: 'edit-light-theme',
            label: '编辑蓝牙开关'
        }],

        ['deleteBlueTooth', {
            url: '/admin/deviceSwitch/delete',
            name: 'delete-light-theme',
            label: '删除蓝牙开关'
        }]
        // ['getBlueToothDetail', {
        
        
        //     name: 'detail',
        //     label: '详情',
        //     // hidden: true
        // }]
    ])


    // // 蓝牙开关列表
    public getBlueToothTableList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
      const apiUrls = this.apiUrls

      const url = apiUrls.get('getBlueToothTableList').url

      this.BasicPost(url, {
          ...params
      }, false, false, false, successCb, failCb, showLoading)
    }

    // // 添加蓝牙开关
    public addBlueTooth(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
      const apiUrls = this.apiUrls

      const url = apiUrls.get('addBlueTooth').url

      this.BasicPost(url, {
          ...params
      }, false, false, false, successCb, failCb, showLoading)
    }

    // 编辑蓝牙开关
    public editBlueTooth(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
      const apiUrls = this.apiUrls

      const url = apiUrls.get('editBlueTooth').url

      this.BasicPost(url, {
          ...params
      }, false, false, false, successCb, failCb, showLoading)
    }

    // 编辑蓝牙开关
    public deleteBlueTooth(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
      const apiUrls = this.apiUrls

      const url = apiUrls.get('deleteBlueTooth').url

      this.BasicPost(url, {
          ...params
      }, false, false, false, successCb, failCb, showLoading)
    }
}